//@flow
import React from 'react';

import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import SwitchableSection from '../../../../../elements/SwitchableSection';
import EditAboutUs from './EditAboutUs';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import {useStoreUiInformation} from '../../../../ui/utils';

const useStyles = makeStyles(theme => ({
  disabledRoot: {
    background: colors.grey300,
  },
}));

type Props = {
  sectionEnabled?: boolean,
};

export default function AboutUsSection(props: Props) {
  const {sectionEnabled} = props;
  const classes = useStyles();
  const storeUiInformation = useStoreUiInformation();

  const emptyContent =
    !storeUiInformation ||
    !storeUiInformation?.profileInformation?.description ||
    !storeUiInformation?.profileInformation?.profilePhotoId;

  return (
    <>
      <SwitchableSection
        id={HOME_PAGE_SECTION_NAMES.STORE_PROFILE}
        title="Conócenos"
        subtitle="Usa esta sección para presentarte al cliente y generar confianza antes de la compra. Recomendamos grabar un video en TikTok o Youtube y colocar el enlace."
        hideSwitch
        classes={{
          root: emptyContent || !sectionEnabled ? classes.disabledRoot : '',
        }}
      >
        <EditAboutUs />
        {/*         <Button
          fullWidth
          color="primary"
          className={classes.addAboutUsSectionBtn}
          component={Link}
          to="/my-store/pages/home-page/about-us"
        >
          Agregar sección
        </Button> */}
      </SwitchableSection>
    </>
  );
}
